<template>
  <common-dialog
    ref="dialog"
    :title="title"
    width="1200px"
    :in-dialog="inDialog"
  >
    <el-container>
      <el-main class="my-main">
        <list
          ref="list"
          :show-checkbox="multiple"
          :checkbox-fixed="false"
          :show-status="false"
          is-mall-goods
        >
          <template #column>
            <slot name="column" />
            <template v-if="selectable && !multiple">
              <el-table-column
                label="操作"
                align="center"
                width="60"
                fixed="right"
              >
                <template slot-scope="{ row }">
                  <el-button @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
      </el-main>
    </el-container>
    <template slot="footer">
      <slot name="footer">
        <el-button
          size="mini"
          type="primary"
          @click="selectMultiple"
          v-if="selectable && multiple"
          >选择</el-button
        >
          <el-button @click="close">关 闭</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./orderList";
import listDialogMixins from "@/mixins/listDialog";

export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "缴费列表",
    },
  },
  data() {
    return {
      data: {
        TypeName: "",
        TypeId: 0,
        TypeIdChain: "",
        TypeNameChain: "",
        TypePlatformIdChain: "",
        TypePlatformName: "",
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      params: {
      },
    };
  },
  methods: {   
    getData(params) {
      this.params = { ...params };
      this.$refs.list.getData(this.params);
    },
    allData() {
      this.resetSelect();
      this.$refs.list.getData({ ...this.params,});
      //
    },
    resetSelect() {
      
    },
  
  },
};
</script>
<style lang="scss" scoped>
.my-aside {
  margin-top: 20px;
}
</style>